import React from "react";
import MultiButton from "../../../Docuclipper/MultiButton";
import { useDispatch } from "react-redux";
import {
  updateTemplateField,
  fieldSectionSetExpanded,
  fetchExtractedData,
  setNumColumns,
} from "../../../../redux/reducers/TemplateField";
import { TemplateFieldV2 } from "../../../../docuclipper/DocuclipperTypes";
import { withSelectedField } from "./withSelectedField";
type Props = {
  field: TemplateFieldV2;
};
export const _LocationSelector: React.SFC<Props> = ({ field }) => {
  const dispatch = useDispatch();

  return (
    <>
      {/* <div className="h5">Position type</div> */}
      <MultiButton
        btnClassName="w100"
        selected={field.locationType}
        onSelect={(option) => {
          const value = option.apiName as TemplateFieldV2["locationType"];
          dispatch(
            updateTemplateField({
              id: field.id,
              update: {
                locationType: value,
              },
            })
          );
          dispatch(fetchExtractedData({ id: field.id }));

          if (value === "fixed") {
            dispatch(
              setNumColumns({
                numColumns: field.tableConfig.columns.length,
                id: field.id,
              })
            );
          }

          if (value === "variable") {
            dispatch(
              fieldSectionSetExpanded({
                name: "topEdge",
                expanded: true,
              })
            );
            dispatch(
              fieldSectionSetExpanded({
                name: "variableLocation",
                expanded: true,
              })
            );
          }
        }}
        options={[
          { text: "Fixed", apiName: "fixed", icon: "" as any },
          { text: "Variable", apiName: "variable", icon: "" as any },
        ]}
      />
    </>
  );
};
export const LocationSelector = withSelectedField(_LocationSelector);
